import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import { governingMinistryService } from "../../../services/governingMinistry.service";
import CustomTextInput from "../../../components/CustomTextInput";

export default function GoverningMinistryForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: governingMinistryService.findById,
    queryKey: ["governing-ministry"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: governingMinistryService,
    form: form,
    messageApi: messageApi,
    queryKey: "governing-ministry",
    route: "/master-data/governing-ministry",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isPending || updateMutation.isPending;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Kementerian Pengampu"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/governing-ministry"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama Kementerian"
            name="name"
            rules={[{ required: true, message: "Nama Kementerian harus diisi" }]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
